<template>
    <div class="pad-performance-change-info-wrap">
        <div class="pad-performance-change-info">
            <div class="title-container">
                <span class="sub-title">变更前</span>
                <i :class="oldContentVisible ? 'el-icon-arrow-down' : 'el-icon-arrow-up'" @click="handleCollapseOld"></i>
            </div>
            <div class="content" v-if="oldContentVisible">
                <ScoreForm ref="oldSfRef" :operateType="operateType"/>
            </div>
        </div>
        <div class="pad-performance-change-info">
            <div class="title-container">
                <span class="sub-title">变更后</span>
                <i :class="newContentVisible ? 'el-icon-arrow-down' : 'el-icon-arrow-up'" @click="handleCollapseNew"></i>
            </div>
            <div class="content" v-if="newContentVisible">
                <ScoreForm ref="newSfRef" :operateType="operateType" :changeKeys="changeKeys"/>
            </div>
        </div>
    </div>
</template>
<script>
import { getChangeInfo } from '../../../api/warehouseResourceManagement/performanceAssessDetail.js';
import ScoreForm from './ScoreForm.vue';

export default {
    components: { ScoreForm },
    props: {
        auditId: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            oldContentVisible: true,
            newContentVisible: true,
            operateType: 'audit',
            changeKeys: [],
        };
    },
    methods: {
        loadData() {
            getChangeInfo(this.auditId).then(res => {
                if (res && +res.code === 0) {
                    this.setFormData(res.data)
                }
            }).catch(err => {})
        },
        setFormData(data) {
            this.$refs.oldSfRef.setData(data.previousInfo)
            this.$refs.newSfRef.setData(data.currentInfo)
            if (data.changeFlagInfo) {
                Object.keys(data.changeFlagInfo).forEach(key => {
                    if (data.changeFlagInfo[key]) {
                        this.changeKeys.push(key.replace('Flag', ''))
                    }
                })
            }
        },
        handleCollapseOld() {
            this.oldContentVisible = !this.oldContentVisible
        },
        handleCollapseNew() {
            this.newContentVisible = !this.newContentVisible
        },
    },
    mounted() {
        this.loadData()
    },
};
</script>
<style lang="less" scoped>
.pad-performance-change-info {
    font-size: 12px;
    color: #555757;

    .sub-title {
        display: inline-block;
        font-size: 14px;
        font-weight: bold;
        color: #000;
    }

    .title-container {
        margin-bottom: 5px;

        i {
            float: right;
            padding-right: 10px;
            font-size: 24px;
            cursor: pointer;
        }
    }
}
</style>
